import React from "react";
import axios from "axios";
import lodash from "lodash";
import HotTable from "react-handsontable";

import Loading from "../general/Loading";
import Filtering from "./Filtering";
import { buildData } from "./data";

const emptyData = n => new Array(n).fill("").map(() => ({}));

class ChemicalRecordsImporter extends React.Component {
  state = {
    dataPools: [],
    loading: true,
    pool: null,
    rows: {}
  };

  get currentKey() {
    const { pool } = this.state;
    return `${pool.id}:${pool.location_id}`;
  }

  componentWillMount() {
    axios
      .get("/pools.json?active=1&archived=0&include=location")
      .then(({ data }) => {
        this.dataLoaded(data);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  dataLoaded = data => {
    const { currentLocations } = window.Application;
    let dataPools = [];

    lodash.forEach(currentLocations, location => {
      const pools = lodash.filter(data, { location_id: location.id });
      if (pools.length > 0) {
        dataPools = dataPools.concat(pools);
      }
    });

    this.setState(
      { loading: false, pool: dataPools[0], dataPools },
      this.clearRows
    );
  };

  clearRows = () => {
    const rows = {};
    lodash.each(this.state.dataPools, item => {
      rows[`${item.id}:${item.location_id}`] = emptyData(25);
    });
    this.setState({ rows: rows });
  };

  changePool = pool => this.setState({ pool });

  handlerAddRows = () => {
    const { rows } = this.state;

    rows[this.currentKey] = rows[this.currentKey].concat(emptyData(25));
    this.setState({ rows: rows });

    toastr.success("Rows added");
  };

  handlerReset = () => {
    this.clearRows();

    toastr.success("Grid has been cleared");
  };

  handlerImport = () => {
    const data = this.preparingData();

    axios
      .post("/chemical_records/import", { chemical_records: data })
      .then(() => {
        toastr.success("Chemical Records Import Started...");
        this.clearRows();
      })
      .catch(() => {
        toastr.error("Chemical Records not imported");
      });
  };

  preparingData = () => {
    const { rows } = this.state;
    let data = [];

    lodash.forOwn(rows, (row, key) => {
      const plID = key.split(":");
      const cleanedRows = lodash.filter(row, r => Object.keys(r).length > 0);
      const result = lodash.map(cleanedRows, r => {
        r.pool_id = parseInt(plID[0]);
        r.location_id = parseInt(plID[1]);
        return r;
      });

      data = data.concat(result);
    });

    return data;
  };

  render() {
    const { dataPools, pool, rows, loading } = this.state;
    const data = loading ? [] : rows[this.currentKey];
    const tableData = loading ? {} : buildData(pool);

    return (
      <div>
        <h1>Chemical Records Importer</h1>

        {loading ? (
          <Loading loading={true} />
        ) : (
          <div>
            <Filtering
              pool={pool}
              dataPools={dataPools}
              onChangePool={this.changePool}
              onImport={this.handlerImport}
              onAddRows={this.handlerAddRows}
              onReset={this.handlerReset}
            />

            <HotTable
              root="hot"
              width={1200}
              height={500}
              data={data}
              colHeaders={true}
              rowHeaders={false}
              colWidths={tableData.colWidths}
              colHeaders={tableData.colHeaders}
              columns={tableData.columns}
            />
          </div>
        )}

        <br />

        <p className="grey-text">
          Note: Importing chemical records will not trigger text message or
          email alerts.
        </p>
      </div>
    );
  }
}

export default ChemicalRecordsImporter;
